import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PRICES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updatePricesAction = createAsyncThunk(
    'price/updatePricesAction',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ PRICES_PATH }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updatePricesSlice = createSlice({
    name: 'updatePricesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updatePricesAction.pending, () => STATE__API__STARTED);
        builder.addCase(updatePricesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updatePricesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updatePricesState = (state) => state.price.updatePrices;
export default updatePricesSlice.reducer;